import { InjectionToken } from '@angular/core';

export const kitMomentInstance = new InjectionToken('KitMomentInstance');
